<template lang="pug">
#modal-download-instruction.modal.modal-lg.fade(tabindex='-1')
  .modal-dialog
    .modal-content
      .modal-header
        h1#messageModalAreYouShure.modal-title.fs-5 Download do emissor
        button.btn-close(
          type='button',
          data-bs-dismiss='modal',
          aria-label='Fechar'
        )
      .modal-body.pt-1
        .java-information.d-flex
          .img-container
            img(src='@/assets/images/logo_java.svg', alt='Logo Java')
          .description.px-3.pt-1
            .text.text-start.fs-6.mb-2 Antes de fazer o download do emissor, você precisa ter o Java
              |
              | instalado e atualizado em seu computador.
            .text.text-start.fs-6
              a.link(href='https://www.java.com/pt-BR/', target='_blank')
                span Clique aqui para fazer o download
                Icon.mx-2.icon(name='download')
        .text.text-start.fs-6.mt-3
          |#[strong Após o download, siga os passos até a conclusão da instalação.]
        .text.text-start.mt-3
          Icon.icon.pe-1(
            name='circle-check',
            style='color: var(--color-success)'
          )
          span.fs-6 Tenha em mãos seu #[strong usuário*] e a senha de emissão do
            |
            | seu Certificado Digital.
        .text.text-start.fs-6.mt-4.mx-4 * Você pode encontrar seu código de usuário em seu
          |
          | e-mail com o texto: “Emissão de Certificado Digital APROVADA” no assunto.
      .modal-footer
        a#dowload-link(v-show='false', :href='issuerUrl')
        button.btn.modal-footer_btn-process.btn-primary(
          @click='download',
          data-bs-dismiss='modal'
        )
          Icon.me-2(name='download')
          span Baixar emissor
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Icon from '@/components/Atoms/Icon.vue'
  import { mapState } from 'pinia'
  import { useAR, ArDataType } from '@/store/Pinia/useAR.store'

  export default defineComponent({
    name: 'ModalDownloadInstruction',
    components: {
      Icon,
    },
    data: () => ({
      form: {
        arData: {} as ArDataType,
      },
    }),
    computed: {
      ...mapState(useAR, ['arData']),
      issuerUrl() {
        return `https://${this.form.arData.subdomain}.acsoluti.com.br/renovacao/jnlp`
      },
    },
    mounted() {
      this.form.arData = this.arData
    },
    methods: {
      download() {
        ;(document.getElementById('dowload-link') as HTMLAnchorElement).click()
      },
    },
  })
</script>

<style lang="stylus" scoped>
  .java-information
    background: #E6E7EC
    border-radius: 10px
    padding: 1rem

  .link
    color: #0080A3
</style>
